export default "__VITE_ASSET__D15xb$4v__"